module.exports = __webpack_public_path__ + "img/white02_128.de41c7f0.png";